import Select from 'antd/es/select';
import CreateAntField from './CreateAntField';

export default CreateAntField(Select);
